import { z } from "zod"
import { type Scalar } from "@/graphql"

export type JourneyType = Exclude<Scalar<"JourneyType">, "NONE">

export const JourneyType = {
    CHANGE_OF_SUPPLIER: "CHANGE_OF_SUPPLIER",
    COMMISSIONING: "COMMISSIONING",
} as const satisfies Record<JourneyType, JourneyType>

export const JourneyTypeSchema = z.enum(JourneyType)
